module.exports = __webpack_public_path__ + "common/images/polaris.png";


//////////////////
// WEBPACK FOOTER
// ./Common/images/polaris.png
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7